import { TaskAssigneePrivacyEnum } from '@/bundles/Tasks/types';

export const colorByAssigneeDictionary: Record<TaskAssigneePrivacyEnum, string> = {
  [TaskAssigneePrivacyEnum.me]: '#1976D2', // My Tasks
  [TaskAssigneePrivacyEnum.by_me]: '#F57C00', // My Assignments
  [TaskAssigneePrivacyEnum.my_team]: '#BDBDBD', // My Team's Tasks
};

export const getTaskColorByAssignee = (type: TaskAssigneePrivacyEnum): string => {
  return colorByAssigneeDictionary[type];
}
